module.exports = __webpack_public_path__ + "media/ui/icons-053f5c84.svg";